import {
  normalizeFileName,
  resolvePath,
  AppRegistry,
  FetchAppData,
  Unzip,
  isDev,
  config,
  LOG
} from '@webrcade/app-common'

import A5200_PROPS from './props/A5200Props.json';
import COLECO_PROPS from './props/ColecoProps.json';
import ASTROCADE_PROPS from './props/AstrocadeProps.json';
import { getJaguarMappings } from './mappings/jaguar';
import { getJaguarCdMappings } from './mappings/jaguarcd';

class GameRegistryImpl {
  constructor() {
    this.db = {};

    this.CUSTOM_PROPS = {...this.CUSTOM_PROPS, ...COLECO_PROPS, ...A5200_PROPS, ...ASTROCADE_PROPS};
    // console.log(this.CUSTOM_PROPS)
  }

  DB_FILE = !isDev() ? resolvePath("roms.json.zip") : `http://${config.getLocalExternalIp()}:${config.getLocalPort()}/roms.json.zip`;
  CHEAT_DB_FILE = 'https://raw.githubusercontent.com/webrcade-assets/libdb/master/cht/wrc-cheats.json.zip';

  cheatDb = null;
  // eslint-disable-next-line
  TITLE_REGEX = /^([^\(]*).*$/i

  AUTOCOMPLETE = {}

  METADATA = {
    '2600': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-2600-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-2600-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Atari%202600/output'
    },
    '5200': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-5200-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-5200-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Atari%205200/output'
    },
    '7800': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-7800-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-7800-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Atari%207800/output'
    },
    'gba': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-gba-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-gba-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Nintendo%20Game%20Boy%20Advance/output'
    },
    'nes': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-nes-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-nes-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Nintendo%20Entertainment%20System/output'
    },
    'snes': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-snes-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-snes-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Super%20Nintendo%20Entertainment%20System/output'
    },
    'sms': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-sms-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-sms-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Sega%20Master%20System/output'
    },
    'gg': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-gg-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-gg-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Sega%20Game%20Gear/output'
    },
    'genesis': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-genesis-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-genesis-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Sega%20Genesis/output'
    },
    'sg1000': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-sg1000-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-sg1000-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Sega%20SG-1000/output'
    },
    'gb': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-gb-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-gb-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Nintendo%20Game%20Boy/output'
    },
    'gbc': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-gbc-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-gbc-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Nintendo%20Game%20Boy%20Color/output'
    },
    'n64': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-n64-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-n64-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Nintendo%2064/output'
    },
    'pce': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-pce-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-pce-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/NEC%20PC%20Engine/output'
    },
    'sgx': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-sgx-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-sgx-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/NEC%20SuperGrafx/output'
    },
    'ngp': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-ngp-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-ngp-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/SNK%20Neo%20Geo%20Pocket/output'
    },
    'ngc': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-ngc-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-ngc-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/SNK%20Neo%20Geo%20Pocket%20Color/output'
    },
    'wsc': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-wsc-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-wsc-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Bandai%20WonderSwan%20Color/output'
    },
    'ws': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-ws-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-ws-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Bandai%20WonderSwan/output'
    },
    'vb': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-vb-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-vb-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Nintendo%20Virtual%20Boy/output'
    },
    'lnx': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-lnx-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-lnx-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Atari%20Lynx/output'
    },
    'neogeo': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-neogeo-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-neogeo-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/SNK%20Neo%20Geo/output'
    },
    'arcade': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-fbneo-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-fbneo-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Arcade/output'
    },
    'arcade-capcom': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-fbneo-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-fbneo-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Arcade/output'
    },
    'arcade-konami': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-fbneo-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-fbneo-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Arcade/output'
    },
    'psx': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-psx-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-psx-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Sony%20PlayStation%201/output'
    },
    'segacd': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-segacd-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-segacd-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Sega%20CD/output'
    },
    'pcecd': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-pcecd-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-pcecd-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/NEC%20PC%20Engine-CD/output'
    },
    'coleco': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-coleco-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-coleco-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/ColecoVision/output'
    },
    'pcfx': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-pcfx-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-pcfx-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/NEC%20PC-FX/output'
    },
    'neogeocd': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-neogeocd-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-neogeocd-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/SNK%20Neo%20Geo%20CD/output'
    },
    'quake': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-quake-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-quake-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Quake/output'
    },
    '3do': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-3do-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-3do-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Panasonic%203DO/output'
    },
    'scumm': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-scummvm-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-scummvm-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/ScummVM%20Descriptions'
    },
    'commodore-c64': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-commodore-64-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-commodore-64-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Commodore%2064'
    },
    'dos': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-dos-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-dos-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/DOS'
    },
    'nds': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-nds-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-nds-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Nintendo%20DS'
    },
    'pokemini': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-pokemini-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-pokemini-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Pokemini'
    },
    'saturn': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-saturn-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-saturn-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Saturn'
    },
    'astrocade': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-astrocade-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-astrocade-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Bally%20Astrocade'
    },
    'cdi': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-cdi-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-cdi-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Philips%20CD-i'
    },
    'apple2': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-apple2-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-apple2-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Apple%20II'
    },
    'apple2gs': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-apple2gs-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-apple2gs-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Apple%20IIGS'
    },
    '32x': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-32x-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-32x-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Sega%2032X/output'
    },
    '32xcd': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-32xcd-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-32xcd-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Sega%20CD%2032X/output'
    },
    'jaguar': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-jaguar-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-jaguar-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Atari%20Jaguar/output'
    },
    'jaguarcd': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-jaguar-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-jaguar-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Atari%20Jaguar%20CD/output'
    },
    'dreamcast': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-dreamcast-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-dreamcast-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Sega%20Dreamcast/output'
    },
    'psp': {
      thumbPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-psp-images/master/Named_Titles/resized',
      backPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-psp-images/master/Named_Snaps/output',
      descriptionPrefix: 'https://raw.githubusercontent.com/webrcade-assets/webrcade-assets-metadata/master/descriptions/Sony%20PSP/output'
    },
  }

  CUSTOM_PROPS = {
    /* Genesis */

    // Ms. Pac-Man
    "cfe7f3023b21bcf697bcf5e1be461ee7": { pad3button: true },

    /* 2600 */

    // Air Sea Battle
    "16cb43492987d2f32b423817cdaaf7c4": { swap: true },
    // Bachelor Party
    "5b124850de9eea66781a50b2e9837000": { port0: 2, paddleSensitivity: 16, paddleVertical: true, paddleInverted: true, paddleCenter: -10 },
    // Basketball
    "ab4ac994865fb16ebb85738316309457": { swap: true },
    // Beat'Em & Eat'Em (Brazil) (Unl)
    "6c25f58fd184632ca76020f589bb3767": { port0: 2, port1: 2, paddleSensitivity: -50, paddleCenter: 20},
    // Beat'Em & Eat'Em (Europe)
    "b4f31ea8a6cc9f1fd4d5585a87c3b487": { port0: 2, port1: 2, paddleSensitivity: -50, paddleCenter: 20},
    // Beat'Em & Eat'Em (USA)
    "59e96de9628e8373d1c685f5e57dcf10": { port0: 2, port1: 2, paddleSensitivity: -50, paddleCenter: 20},
    // Breakout (Europe)
    "6c76fe09aa8b39ee52035e0da6d0808b": { port0: 2, port1: 2, paddleCenter: -16 },
    // Breakout (Japan, USA)
    "f34f08e5eb96e500e851a80be3277a56": { port0: 2, port1: 2, paddleCenter: -16 },
    // Bugs (Europe)
    "e61210293b14c9c4ecc91705072c6a7e": { port0: 2, port1: 2, paddleCenter: 16 },
    // Bugs (USA)
    "68597264c8e57ada93be3a5be4565096": { port0: 2, port1: 2, paddleCenter: 16 },
    // Bumper Bash (Europe)
    "16ee443c990215f61f7dd1e55a0d2256": { port0: 1 },
    // Bumper Bash (USA)
    "aa1c41f86ec44c0a44eb64c332ce08af": { port0: 1 },
    // Canyon Bomber (USA)
    "feedcc20bc3ca34851cd5d9e38aa2ca6": { port0: 2, port1: 2, paddleVertical: true, paddleCenter: -20, paddleSensitivity: -40 },
    // Casino (Europe)
    "2bc26619e31710a9884c110d8430c1da": { paddleSensitivity: 40, port0: 2, port1: 2 },
    // Casino (USA)
    "b816296311019ab69a21cb9e9e235d12": { paddleSensitivity: 40, port0: 2, port1: 2 },
    // Circus Atari (Europe)
    "30e0ab8be713208ae9a978b34e9e8e8c": { port0: 2, port1: 2, paddleSensitivity: -20 },
    // Circus Atari (Japan, USA)
    "a7b96a8150600b3e800a4689c3ec60a2": { port0: 2, port1: 2, paddleSensitivity: -20 },
    // Demons to Diamonds (USA)
    "f91fb8da3223b79f1c9a07b77ebfa0b2": { port0: 2, port1: 2, paddleSensitivity: -20 },
    // Eggomania (USA)
    "42b2c3b4545f1499a083cfbc4a3b7640": { port0: 2, port1: 2, paddleCenter: -20 },
    // Fireball (USA)
    "386ff28ac5e254ba1b1bac6916bcc93a": { port0: 2, port1: 2, paddleSensitivity: -20 },
    // G.I. Joe - Cobra Strike (USA)
    "c1fdd44efda916414be3527a47752c75": { port0: 1 },
    // Guardian (USA)
    "7ab2f190d4e59e8742e76a6e870b567e": { port0: 2, port1: 2, paddleCenter: -20, paddleSensitivity: 20 },
    // Home Run
    "0bfabf1e98bdb180643f35f2165995d0": { swap: true },
    // Kaboom!
    "5428cdfada281c569c74c7308c7f2c26": { port0: 2, port1: 2 },
    // Music Machine, The (USA)
    "65b106eba3e45f3dab72ea907f39f8b4": { port0: 2, port1: 2,  paddleCenter: 20 },
    // Night Driver
    "392f00fd1a074a3c15bc96b0a57d52a1": { port0: 2, port1: 2 },
    // Party Mix (USA)
    "012b8e6ef3b5fd5aabc94075c527709d": { port0: 2, port1: 2, paddleCenter: -20 },
    // Picnic (USA)
    "17c0a63f9a680e7a61beba81692d9297": { port0: 2, port1: 2, paddleCenter: 30, paddleSensitivity: -20 },
    // Piece o' Cake (USA)
    "d3423d7600879174c038f53e5ebbf9d3": { port0: 2, port1: 2, paddleCenter: -20 },
    // Solar Storm (USA)
    "97842fe847e8eb71263d6f92f7e122bd": { port0: 2, port1: 2, paddleCenter: 20, paddleSensitivity: -20 },
    // Star Wars - Jedi Arena (USA)
    "c9f6e521a49a2d15dac56b6ddb3fb4c7": { port0: 2, port1: 2, paddleSensitivity: -20 },
    // Steeplechase (Europe)
    "f1eeeccc4bba6999345a2575ae96508e": { port0: 2, port1: 2 },
    // Steeplechase (USA)
    "656dc247db2871766dffd978c71da80c": { port0: 2, port1: 2 },
    // Street Racer (USA)
    "396f7bc90ab4fa4975f8c74abe4e81f0": { port0: 2, port1: 2 },
    // Super Breakout (USA)
    "8885d0ce11c5b40c3a8a8d9ed28cefef": { port0: 2, port1: 2 },
    // Super Breakout (USA, Europe) (Atari Anthology)
    "0ad9a358e361256b94f3fb4f2fa5a3b1": { port0: 2, port1: 2 },
    // Surround
    "4d7517ae69f95cfbc053be01312b7dba": { swap: true },
    // Tac-Scan (USA)
    "d45ebf130ed9070ea8ebd56176e48a38": { port0: 2, port1: 2 },
    // Video Olympics (USA)
    "60e0ea3cbe0913d39803477945e9e5ec": { port0: 2, port1: 2, paddleVertical: true, paddleCenter: -10 },
    // Warlords
    "cbe5a166550a8129a5e6d374901dffad": { port0: 2, port1: 2 },
    // Warplock (USA)
    "679e910b27406c6a2072f9569ae35fc8": { port0: 2, port1: 2, paddleCenter: 20 },

    /* NES */

    // Driar
    "ac6adbbc2f43faa64a86463c1a594aee": { pal: true },
    // Elite
    "ada42a2576d85b29da663bbf35b69288": { pal: true },
    "2c832d9fac3229cb7c32a5fe1dd65ad7": { pal: true },

    /* GBA */

    // Anguna
    "9d3a663de5228414d7e6cda7244c5d91": { saveType: 2, flashSize: 65536 },
    // Another World
    "9cef2ca9fba8a4532629f8c7e7c9ddf8": { saveType: 2, flashSize: 65536 },
    // Blast Arena Advance
    "10f2557e1deb8629c04c071cd180c707": { saveType: 2, flashSize: 65536 },
    "cde17fc4f3d41365cb92dd1187196cd8": { saveType: 2, flashSize: 65536 },
    // Broken Circle
    "420a1cf3e052ec30d3612d7d945c525e": { saveType: 1 },
    // Flappy Bird
    "38f78ab97bbbb9bd210d8c96497f788a": { rotation: 270, saveType: 2, flashSize: 65536 },
    // POWDER
    "09f9a4252a88f839f40fdfb44942cb20": { saveType: 2, flashSize: 65536 },
    // SM Quest
    "d6b69c7d686163350141a5860d1599ad": { saveType: 2 },

    /* SMS */

    // DARC
    "466f43446d151b9e6793212d5ce8c373": { ym2413: true },
    // Flight of Pigarus
    "42b79384a1352b47b9ea32d6d3ec6849": { pal: true },
    // Mecha 8
    "d736dc90807bea45e2dc7aa3ff2e8be9": { ym2413: true },

    /* DOOM */

    // Freedoom Phase 1
    "c92783594290d9259017cadd746a62bb": { game: "freedoom1" },
    // Freedoom Phase 2
    "88e0c5180391f5b4eedea0f06df24c4c": { game: "freedoom2" },
    // Doom 1 (Shareware)
    "9c69ed31b99047073cbe9a5aaf616b5b": { game: "doom1" },

    /* 3DO */

    // Alone in the Dark
    "0999360e91c941469c7fceb8b20c6df5": { hack: 4},
    "abedff17853f355ba2b2238ea0d465cc": { hack: 4},
    "49564f60b021fbd59f95f39acf6cbd8d": { hack: 4},
    "192de93ff970cc04caa49d4a723a390f": { hack: 4},
    "4224f017a7b91bfdd69814e2c9fd7c22": { hack: 4},

    // Crash 'n Burn
    "088b32295489444bdfec469e4f074a71": { hack: 1},
    "95f1ba427b83c958bc32974e04007a40": { hack: 1},
    "b62ff1e051a5ed2acc76ad647ee37b50": { hack: 1},

    // DinoPark Tycoon
    "108d2f25ca9a8b09541e30352d59696f": { hack: 2},

    // Microcosm
    "465fdc3bfd701fae4f660a1a1c7c8373": { hack: 3},
    "f680353429def4d3c1e95120fd9c503f": { hack: 3},

    // Samurai Shodown
    "d36d1d26dba93004b33a2d3fae71d03b": { hack: 5},
    "b0a0bf31f20b8a1fc45d2ea552c94540": { hack: 5},
  }

  METADATA_OVERRIDE = {
    // Freedoom Phase 1
    "c92783594290d9259017cadd746a62bb": {
      description: "The Freedoom project aims to create a complete, free content first person shooter game. Phase 1contains four episodes, nine levels each, totalling 36 levels. This game aims for compatibility with The Ultimate Doom mods, also known as plain Doom or Doom 1.",
      thumbnail: "https://play.webrcade.com/default-feed/images/doom/freedoom1-thumb.png",
      background: "https://play.webrcade.com/default-feed/images/doom/freedoom1-background.png"
    },
    // Freedoom Phase 2
    "88e0c5180391f5b4eedea0f06df24c4c": {
      description: "The Freedoom project aims to create a complete, free content first person shooter game. Phase 2 includes 32 levels in one long episode, featuring extra monsters and a double-barrelled shotgun. This project aims for compatibility with Doom II mods.",
      thumbnail: "https://play.webrcade.com/default-feed/images/doom/freedoom2-thumb.png",
      background: "https://play.webrcade.com/default-feed/images/doom/freedoom2-background.png"
    },
    // Doom 1 (Shareware)
    "9c69ed31b99047073cbe9a5aaf616b5b": {
      description: "Doom is a 1993 first-person shooter (FPS) game developed by id Software for MS-DOS. Players assume the role of a space marine, popularly known as Doomguy, fighting his way through hordes of invading demons from Hell. The first episode, comprising nine levels, was distributed freely as shareware and played by an estimated 15–20 million people within two years.",
      thumbnail: "https://play.webrcade.com/default-feed/images/doom/doom1-thumb.png",
      background: "https://play.webrcade.com/default-feed/images/doom/freedoom2-background.png"
    }
  }

  async checkExists(url) {
    try {
      const r = await new FetchAppData(url, { method: "HEAD" })
        .setRetries(0).setProxyDisabled(true).fetch();
      return r.ok;
    } catch (e) {
      LOG.error("Error checking if exists: " + e)
      return false;
    }
  }

  async getText(url) {
    try {
      const r = await new FetchAppData(url)
        .setRetries(0).setProxyDisabled(true).fetch();
      return r.ok ? await r.text() : null;
    } catch (e) {
      LOG.error("Error retrieving text: " + e)
      return null;
    }
  }

//   async init() {
//     const { DB_FILE } = this;
//     try {
//       const expAppsEnabled = settings.isExpAppsEnabled();
//       this.n64enabled = expAppsEnabled;
//       this.a5200enabled = expAppsEnabled;

//       const fad = new FetchAppData(DB_FILE);
//       const res = await fad.fetch();
//       if (res.ok) {
//         let blob = await res.blob();
//         const uz = new Unzip();
//         blob = await uz.unzip(blob, [".json"]);
//         const json = await blob.text();
//         this.db = JSON.parse(json);
//         LOG.info(`Loaded types database (MD5), ${Object.keys(this.db).length} types.`);

//         // Build media based lookups
//         const types = AppRegistry.instance.getAppTypes();
//         const lookups = {};
//         for (let type in types) {
//           const defs = AppRegistry.instance.getDefaultsForType(type);
//           if (true /*defs.media !== undefined || defs.discs !== undefined || defs.archive !== undefined*/) {
//             const alias = AppRegistry.instance.getAlias(type);
//             if (!lookups[alias]) {
//               const typemap = {};
//               lookups[alias] = typemap;
//               const dbmap = this.db[alias];
//               if (dbmap) {
//                 for (let id in dbmap) {
//                   const normalized = this.normalizeTitle(dbmap[id]);
//                   typemap[normalized] = id;
//                   this.addTitleAliases(typemap, normalized, id);
//                 }
//               }
//             }
//           }
//         }
//         this.titleLookups = lookups;
//       }
//     } catch (e) {
//       LOG.error("Error loading types database: " + e);
//     }

// // console.log('[DEBUG] bards entries:',
// //   Object.keys(this.titleLookups?.['commodore-c64'] ?? {}).filter(k => k.includes('bard')));

//     try {
//       const cfad = new FetchAppData(this.CHEAT_DB_FILE);
//       const cres = await cfad.fetch();
//       if (cres.ok) {
//         let cblob = await cres.blob();
//         const cuz = new Unzip();
//         cblob = await cuz.unzip(cblob, [".json"]);
//         const cjson = await cblob.text();
//         this.cheatDb = JSON.parse(cjson);
//         LOG.info(`Loaded cheat database, ${Object.keys(this.cheatDb).length} systems.`);
//       }
//     } catch (e) {
//       LOG.error("Error loading cheat database: " + e);
//     }
//   }

  async init() {
    const { DB_FILE } = this;
    try {
      const fad = new FetchAppData(DB_FILE);
      const res = await fad.fetch();
      if (res.ok) {
        let blob = await res.blob();
        const uz = new Unzip();
        blob = await uz.unzip(blob, [".json"]);
        const json = await blob.text();
        this.db = JSON.parse(json);
        LOG.info(`Loaded types database (MD5), ${Object.keys(this.db).length} types.`);

        // Build media based lookups
        const types = AppRegistry.instance.getAppTypes();
        const lookups = {};
        for (let type in types) {
          const alias = AppRegistry.instance.getAlias(type);
          if (!lookups[alias]) {
            const typemap = {};
            lookups[alias] = typemap;
            const dbmap = this.db[alias];
            if (dbmap) {
              // Pass 1: add primary normalized titles only
              for (let id in dbmap) {
                const normalized = this.normalizeTitle(dbmap[id]);
                typemap[normalized] = id;
              }
              // Pass 2: add aliases — before-sep aliases won't overwrite existing primary entries
              for (let id in dbmap) {
                const normalized = this.normalizeTitle(dbmap[id]);
                this.addTitleAliases(typemap, normalized, id);
              }
            }
          }
        }
        this.titleLookups = lookups;
      }
    } catch (e) {
      LOG.error("Error loading types database: " + e);
    }

    try {
      const cfad = new FetchAppData(this.CHEAT_DB_FILE);
      const cres = await cfad.fetch();
      if (cres.ok) {
        let cblob = await cres.blob();
        const cuz = new Unzip();
        cblob = await cuz.unzip(cblob, [".json"]);
        const cjson = await cblob.text();
        this.cheatDb = JSON.parse(cjson);
        LOG.info(`Loaded cheat database, ${Object.keys(this.cheatDb).length} systems.`);
      }
    } catch (e) {
      LOG.error("Error loading cheat database: " + e);
    }
  }

  async isFileInZip(filename, blob) {
    // Collect filenames from zip
    let filenames = {};
    const uz = new Unzip()
      .setFailIfNotFound(false)
      .setEntriesCallback((e) => {
        for (let i = 0; i < e.length; i++) {
          const name = e[i].filename;
          filenames[name] = name;
        }
      });
    await uz.unzip(blob, [], []);
    console.log(filenames);
    return filenames[filename] !== undefined;
  }

  // async getMetaDataByMediaTitle(type, title) {
  //   const alias = AppRegistry.instance.getAlias(type);
  //   if (!this.titleLookups?.[alias]) return null;
  //   const normalizedTitle = this.normalizeTitle(title);
  //   const id = this.titleLookups[alias][normalizedTitle];
  //   if (id) {
  //     const ret = {};
  //     const foundTitle = this.db[alias][id];
  //     this.addTitles(ret, foundTitle);
  //     ret.type = type;
  //     await this.addMetaData(ret, type, foundTitle);
  //     return ret;
  //   }
  //   return null;
  // }

  TITLE_ALIASES = {
    'commodore-c64': {
      'pirates': "sid meier's pirates",
    },
    'apple2': {
      'one on one': "one-on-one",
    }
  }

  async getMetaDataByMediaTitle(type, title) {

console.log('[DEBUG] entries:',
  Object.keys(this.titleLookups?.['dos'] ?? {}).filter(k => k.includes('games')));

    const alias = AppRegistry.instance.getAlias(type);

    // Check for known title aliases for this type
    const typeAliases = this.TITLE_ALIASES[alias] ?? {};
    const normalized = this.normalizeTitle(title);
    title = typeAliases[normalized] ?? title;

    console.log(`[getMetaDataByMediaTitle] type='${type}' alias='${alias}' title='${title}'`);
    if (!this.titleLookups?.[alias]) {
      console.log(`[getMetaDataByMediaTitle] no titleLookups for alias '${alias}'`);
      return null;
    }

    // Try 1: exact normalized match
    let normalizedTitle = this.normalizeTitle(title);
    console.log(`[getMetaDataByMediaTitle] try1 normalized='${normalizedTitle}'`);
    let id = this.titleLookups[alias][normalizedTitle];
    console.log(`[getMetaDataByMediaTitle] try1 id='${id}'`);
    console.log(`[DEBUG] try2 test: '${normalizedTitle}' regex test: ${/\s1 - /.test(normalizedTitle)}`);

    // Try 2: strip inline ' 1 ' before ' - ' only
    if (!id && /\s1 - /.test(normalizedTitle)) {
      normalizedTitle = normalizedTitle.replace(/\s1 - /, ' - ');
      console.log(`[getMetaDataByMediaTitle] try2 stripped='${normalizedTitle}'`);
      id = this.titleLookups[alias][normalizedTitle];
      console.log(`[getMetaDataByMediaTitle] try2 id='${id}'`);
    }

    // Try 3: strip subtitle after ' - '
    if (!id && normalizedTitle.indexOf(' - ') !== -1) {
      const stripped = normalizedTitle.substring(0, normalizedTitle.indexOf(' - ')).trim();
      console.log(`[getMetaDataByMediaTitle] try3 stripped='${stripped}'`);
      id = this.titleLookups[alias][stripped];
      console.log(`[getMetaDataByMediaTitle] try3 id='${id}'`);
      if (id) normalizedTitle = stripped;
    }

    // Try 4: strip subtitle after ' in the '
    if (!id && normalizedTitle.indexOf(' in the ') !== -1) {
      const stripped = normalizedTitle.substring(0, normalizedTitle.indexOf(' in the ')).trim();
      console.log(`[getMetaDataByMediaTitle] try4 stripped='${stripped}'`);
      id = this.titleLookups[alias][stripped];
      console.log(`[getMetaDataByMediaTitle] try4 id='${id}'`);
      if (id) normalizedTitle = stripped;
    }

    // Try 5: strip trailing ' 1' or ' i' only — never strip 2/3/4 as those have sequels
    if (!id && /\s(1|i)$/.test(normalizedTitle)) {
      const stripped = normalizedTitle.replace(/\s(1|i)$/, '').trim();
      console.log(`[getMetaDataByMediaTitle] try5 stripped='${stripped}'`);
      id = this.titleLookups[alias][stripped];
      console.log(`[getMetaDataByMediaTitle] try5 id='${id}'`);
      if (id) normalizedTitle = stripped;
    }

    if (id) {
      const ret = {};
      const foundTitle = this.db[alias][id];
      this.addTitles(ret, foundTitle);
      ret.type = type;
      await this.addMetaData(ret, alias /*type*/, foundTitle);

      // Jaguar CD is title-matched (no ROM file to hash), so this is the
      // path that actually applies per-game mappings/descriptions for it
      // -- mirrors the "jaguarcd" branch in find(), same id shape
      // ("jaguarcd:N", already resolved above), see mappings/jaguarcd.js.
      if (alias === 'jaguarcd') {
        const { mappings, descriptions, disableFastBlitter } = getJaguarCdMappings(id);
        ret.props = { ...ret.props, mappings, descriptions, disableFastBlitter };
      }

      return ret;
    }

    console.log(`[getMetaDataByMediaTitle] no match found for '${title}' (${type})`);
    return null;
  }

  async findByName(name, ext, blob, isFullName = false, verifyBlob = true) {
    let ret = null;
    const fullName = isFullName ? name : name + "." + ext;
    for (let type in this.db._by_name) {
      const result = this.db._by_name[type][fullName];
      if (result) {
        const file = result[0];
        const name = result[1];
        const fileFound = verifyBlob ? await this.isFileInZip(file, blob) : true;
        if (fileFound) {
          ret = {}
          // Set type
          ret.type = type;
          // Add titles
          this.addTitles(ret, name);
          // Add metadata
          await this.addMetaData(ret, type, name);
          break;
        }
      }
    }
    return ret;
  }

  getAutoCompleteOptions(type) {
    const { AUTOCOMPLETE } = this;

    if (type in AUTOCOMPLETE) {
      return AUTOCOMPLETE[type];
    }

    const titleSet = new Set();
    let entries = this.getTypeEntries(type);

    if (entries) {
      const opts = [];
      for (let h in entries) {
        const title = this.getShortName(entries[h]);
        if (!titleSet.has(title)) {
          titleSet.add(title);
          opts.push({
            title: title,
            key: h,
            byName: false
          })
        }
      }
      AUTOCOMPLETE[type] = opts;
      return opts;
    } else {
      if (this.db && type in this.db._by_name) {
        const opts = [];
        entries = this.db._by_name[type];
        for (let f in entries) {
          const title = this.getShortName(entries[f][1]);
          if (!titleSet.has(title)) {
            titleSet.add(title);
            opts.push({
              title: title,
              key: f,
              byName: true
            })
          }
        }
        AUTOCOMPLETE[type] = opts;
        return opts;
      }
    }

    return [];
  }

  getShortName(name) {
    const { TITLE_REGEX } = this;

    let shortName = null;
    const matches = name.match(TITLE_REGEX);
    if (matches.length > 1) {
      shortName = matches[1].trim();
    }

    if (shortName) {
        // remove version only at the end
        shortName = shortName.replace(/\s*v\d+(\.\d+)+\s*$/g, "");
    }
    if (name) {
        // remove version only at the end
        name = name.replace(/\s*v\d+(\.\d+)+\s*$/g, "");
    }

    return shortName ? shortName : name;
  }

  addTitles(info, name) {
    const { TITLE_REGEX } = this;

    let shortName = null;
    const matches = name.match(TITLE_REGEX);
    if (matches.length > 1) {
      shortName = matches[1].trim();
      // Strip trailing version strings (v1.000, v3.08, etc.) — same pattern
      // as getShortName()/normalizeTitle(), keeps the displayed title clean
      // while longTitle below retains the full original name.
      shortName = shortName.replace(/\s*v\d+(\.\d+)+\s*$/g, "");
    }

    const hasShortName = shortName && shortName.length > 0;

    info.title = hasShortName ? shortName : name;
    if (hasShortName) {
      info.longTitle = name;
    }
  }

  async addMetaData(info, type, name) {
    const { METADATA } = this;

    const md = METADATA[type];
    let file = normalizeFileName(name);
    file = encodeURIComponent(file);
    if (md) {
      if (md.backPrefix) {
        const url = `${md.backPrefix}/${file}.png`;
        if (await this.checkExists(url)) {
          info.background = url;
        }
      }
      if (md.thumbPrefix) {
        const url = `${md.thumbPrefix}/${file}.png`;
        if (await this.checkExists(url)) {
          info.thumbnail = url;
        }
      }
      if (md.descriptionPrefix) {
        const url = `${md.descriptionPrefix}/${file}.txt`;
        const description = await this.getText(url);
        if (description) {
          // const lines = description.split("\n");
          // let trimmed = "";
          // for (let i = 0; i < lines.length; i++) {
          //   const line = lines[i].trim();
          //   if (line.length > 0) {
          //     trimmed += (i > 0) ? (" " + line) : line;
          //   } else {
          //     break;
          //   }
          // }
          info.description = description.trim(); //trimmed;
        }
      }

      if (info.thumbnail && !info.background) {
        info.background = info.thumbnail;
      }
      if (info.background && !info.thumbnail) {
        info.thumbnail = info.background;
      }
      if (info.background) {
        info.backgroundPixelated = true;
      }
    }
  }

  getTypeEntries(type) {
    return type in this.db ? this.db[type] : null;
  }

  getCheatEntry(type) {
    if (!this.cheatDb) return null;
    const alias = AppRegistry.instance.getAlias(type);
    return (alias && this.cheatDb[alias]) ? this.cheatDb[alias] : null;
  }

  async find(md5) {
    let ret = {};
    for (let type in this.db) {
      let name = this.db[type][md5];
      if (name) {
        // Add titles
        this.addTitles(ret, name);

        // Set type
        ret.type = type;

        // Add metadata
        await this.addMetaData(ret, type, name);

        // Lookup metadata override
        const mdOverride = this.METADATA_OVERRIDE[md5];
        if (mdOverride) {
          ret = { ...ret, ...mdOverride };
        }

        // Lookup custom props
        const props = this.CUSTOM_PROPS[md5];
        if (props) {
          const clone = {...props};
          delete clone._name;
          ret.props = clone
        }

        // Overlay platform-wide default mappings + any per-game override
        // (by MD5) on top -- Jaguar needs a numpad mapping to be playable
        // at all, unlike A5200/Coleco's CUSTOM_PROPS entries above which
        // are only for bonus/special controls. See mappings/jaguar.js.
        // Per-game descriptions there are only added once validated
        // against an actual overlay scan, so it's safe to apply
        // unconditionally here -- unrecognized hashes just get the
        // platform-wide defaults (empty descriptions).
        if (type === 'jaguar') {
          const { mappings, descriptions, disableFastBlitter } = getJaguarMappings(md5);
          ret.props = { ...ret.props, mappings, descriptions, disableFastBlitter };
        } else if (type === 'jaguarcd') {
          // Same mechanism, keyed by the stable "jaguarcd:N" id (md5 here
          // is really just the lookup key, generic across types) instead
          // of an MD5 -- there's no ROM file to hash for a CD title. Only
          // covers this find()/dropdown-select path for now, not drag-drop
          // .cdi import -- see mappings/jaguarcd.js.
          const { mappings, descriptions, disableFastBlitter } = getJaguarCdMappings(md5);
          ret.props = { ...ret.props, mappings, descriptions, disableFastBlitter };
        }
        // n64's disableOpenGL2/countPerOp/audioLatency editor-mapping
        // block (mappings/n64.js) removed -- the RETRO_MUPEN64PLUS_NEXT
        // core now controls all three itself (see compat.js's
        // GAME_SETTINGS in webrcade-app-retro-mupen64plus-next) rather
        // than through editor-set props.
      }
    }

    return ret;
  }

//   normalizeTitle = (title) => {
//     title = title.toLowerCase();
//     let search = "("
//     let find = title.indexOf(search);
//     if (find !== -1) {
//       title = title.substring(0, find);
//     }
//     search = "["
//     find = title.indexOf(search);
//     if (find !== -1) {
//       title = title.substring(0, find);
//     }
//     search = ", the"
//     find = title.indexOf(search);
//     if (find !== -1) {
//       title = title.substring(0, find);
//     }
//     if (title.startsWith("the ")) {
//       title = title.substring(4);
//     }

//     title = title.replaceAll("  ", " ");
//     title = title.trim();

//     if (title.endsWith("!")) {
//       title = title.substring(0, title.length - 1);
//     }

//     title = title.replace(/\s*[-:]+$/, '').trim();

// console.log("NORMALIZED TITLE: " + title);

//     return title;
//   }

  normalizeTitle = (title) => {

// console.log('[DEBUG] simon aliases:',
//   Object.keys(this.titleLookups?.['scumm'] ?? {}).filter(k => k.includes('police')));

    title = title.toLowerCase();

    // Underscores → spaces (safe globally)
    title = title.replaceAll('_', ' ');

    // Strip apostrophes — colonel's → colonels, etc.
    title = title.replaceAll("'", "");

    let search = "("
    let find = title.indexOf(search);
    if (find !== -1) {
      title = title.substring(0, find);
    }
    search = "["
    find = title.indexOf(search);
    if (find !== -1) {
      title = title.substring(0, find);
    }

    // Strip disk side indicators (s1, s2 boot, etc.) — leading space prevents false positives
    title = title.replace(/\s+s\d+(\s+\w+)?/, '');

    // Strip trailing version strings (v1.000, v3.08, etc.) — same pattern as
    // getShortName(), which already handles this correctly for autocomplete.
    // Anchored at the end and requires a decimal point, so titles like
    // "Metal Gear Solid V" or "V-Rally" are untouched.
    title = title.replace(/\s*v\d+(\.\d+)+\s*$/g, '');

    // search = ", the"
    // find = title.indexOf(search);
    // if (find !== -1) {
    //   title = title.substring(0, find);
    // }
    title = title.replace(/, the\b/g, '');

    if (title.startsWith("the ")) {
      title = title.substring(4);
    }

    title = title.replaceAll("  ", " ");
    title = title.trim();

    if (title.endsWith("!")) {
      title = title.substring(0, title.length - 1);
    }

    title = title.replace(/\s*[-:]+$/, '').trim();

    title = title.replace(/\s+r\d+$/, '');

    // console.log("NORMALIZED TITLE: " + title);

    return title;
  }

  // addTitleAliases = (typemap, title, id) => {
  //   if (title.indexOf(":") !== -1) {
  //     let updated = title.replaceAll(":", " -");
  //     typemap[updated] = id;
  //     typemap[title.replaceAll(":", "")] = id;
  //     //typemap[title.substring(0, title.indexOf(":"))] = id;
  //   }
  //   if (title.indexOf("g.i. ") !== -1) {
  //     let updated = title.replaceAll("g.i. ", "gi ");
  //     typemap[updated] = id;
  //   }
  //   if (title.indexOf("gi ") !== -1) {
  //     let updated = title.replaceAll("gi ", "g.i. ");
  //     typemap[updated] = id;
  //   }
  //   if (title.endsWith(" 2")) {
  //     typemap[title.substring(0, title.length - 2) + " ii"] = id;
  //   }
  //   if (title.endsWith(" ii")) {
  //     typemap[title.substring(0, title.length - 3) + " 2"] = id;
  //   }
  //   if (title.endsWith(" 3")) {
  //     typemap[title.substring(0, title.length - 2) + " iii"] = id;
  //   }
  //   if (title.endsWith(" iii")) {
  //     typemap[title.substring(0, title.length - 4) + " 3"] = id;
  //   }
  //   if (title.endsWith(" 4")) {
  //     typemap[title.substring(0, title.length - 2) + " iv"] = id;
  //   }
  //   if (title.endsWith(" iv")) {
  //     typemap[title.substring(0, title.length - 3) + " 4"] = id;
  //   }
  //   if (title.endsWith(" part ii")) {
  //     typemap[title.substring(0, title.length - 8) + " ii"] = id;
  //   }
  // }

  // addTitleAliases = (typemap, title, id) => {
  //   if (title.indexOf(":") !== -1) {
  //     let updated = title.replaceAll(":", " -");
  //     typemap[updated] = id;
  //     typemap[title.replaceAll(":", "")] = id;

  //     // Only add before-colon alias if no sequel indicator AFTER the colon
  //     const colonIdx = title.indexOf(":");
  //     const afterColon = title.substring(colonIdx + 1);
  //     const hasSequelAfterColon = /\s*(ii|iii|iv|\d+)(\s|:|$)/.test(afterColon);
  //     if (!hasSequelAfterColon) {
  //       typemap[title.substring(0, colonIdx).trim()] = id;
  //     }
  //   }
  //   if (title.indexOf(" in the ") !== -1) {
  //     let updated = title.substring(0, title.indexOf(" in the "));
  //     typemap[updated] = id;
  //   }
  //   if (title.indexOf(' - ') !== -1) {
  //     typemap[title.substring(0, title.indexOf(' - ')).trim()] = id;
  //   }
  //   if (title.indexOf("g.i. ") !== -1) {
  //     let updated = title.replaceAll("g.i. ", "gi ");
  //     typemap[updated] = id;
  //   }
  //   if (title.indexOf("gi ") !== -1) {
  //     let updated = title.replaceAll("gi ", "g.i. ");
  //     typemap[updated] = id;
  //   }
  //   if (title.indexOf(" & ") !== -1) {
  //     let updated = title.replaceAll(" & ", " and ");
  //     typemap[updated] = id;
  //   }
  //   if (title.indexOf(" and ") !== -1) {
  //     let updated = title.replaceAll(" and ", " & ");
  //     typemap[updated] = id;
  //   }
  //   if (title.endsWith(" part ii")) {
  //     typemap[title.substring(0, title.length - 8) + " ii"] = id;
  //   }
  //   if (title.indexOf('leaderboard') !== -1) {
  //     typemap[title.replace('leaderboard', 'leader board')] = id;
  //   }
  //   if (title.indexOf('leader board') !== -1) {
  //     typemap[title.replace('leader board', 'leaderboard')] = id;
  //   }

  //   // Roman <-> Arabic anywhere in title (longest match first to avoid ' ii' matching inside ' iii')
  //   // No 'g' flag — avoids stateful lastIndex bug with test() + replace()
  //   const romanArabicPairs = [
  //     [' iv', ' 4'],
  //     [' iii', ' 3'],
  //     [' ii', ' 2'],
  //   ];
  //   for (const [roman, arabic] of romanArabicPairs) {
  //     const romanRe = new RegExp(`${roman}(?=\\s|:|$|-|\\.)`);
  //     const arabicRe = new RegExp(`${arabic}(?=\\s|:|$|-|\\.)`);

  //     if (romanRe.test(title)) {
  //       const aliased = title.replace(romanRe, arabic);
  //       typemap[aliased] = id;
  //       const colonIdx = aliased.indexOf(':');
  //       if (colonIdx !== -1) {
  //         typemap[aliased.substring(0, colonIdx).trim()] = id;
  //       }
  //       const dashIdx = aliased.indexOf(' - ');
  //       if (dashIdx !== -1) {
  //         typemap[aliased.substring(0, dashIdx).trim()] = id;
  //       }
  //     }
  //     if (arabicRe.test(title)) {
  //       const aliased = title.replace(arabicRe, roman);
  //       typemap[aliased] = id;
  //       const colonIdx = aliased.indexOf(':');
  //       if (colonIdx !== -1) {
  //         typemap[aliased.substring(0, colonIdx).trim()] = id;
  //       }
  //       const dashIdx = aliased.indexOf(' - ');
  //       if (dashIdx !== -1) {
  //         typemap[aliased.substring(0, dashIdx).trim()] = id;
  //       }
  //     }
  //   }
  // }

  addTitleAliases = (typemap, title, id) => {
    // Helper: check if a string starts with a sequel indicator (roman numeral or number)
    const hasSequel = (str) => /^\s*(ii|iii|iv|v|vi|vii|viii|ix|x|\d+)(\s|:|$)/.test(str);

    // Helper: add before-separator alias only if:
    // 1. No sequel indicator after the separator
    // 2. Key doesn't already exist as a primary entry (prevents false positives like Lode Runner)
    const addBeforeSep = (t, sepIdx, sepLen) => {
      const after = t.substring(sepIdx + sepLen);
      if (!hasSequel(after)) {
        const key = t.substring(0, sepIdx).trim();
        if (!typemap[key]) {
          typemap[key] = id;
        }
      }
    };

    if (title.indexOf(":") !== -1) {
      typemap[title.replaceAll(":", " -")] = id;
      typemap[title.replaceAll(":", "")] = id;
      addBeforeSep(title, title.indexOf(":"), 1);
    }
    if (title.indexOf(" in the ") !== -1) {
      typemap[title.substring(0, title.indexOf(" in the "))] = id;
    }
    if (title.indexOf(' - ') !== -1) {
      addBeforeSep(title, title.indexOf(' - '), 3);
    }
    if (title.indexOf("g.i. ") !== -1) {
      typemap[title.replaceAll("g.i. ", "gi ")] = id;
    }
    if (title.indexOf("gi ") !== -1) {
      typemap[title.replaceAll("gi ", "g.i. ")] = id;
    }
    if (title.indexOf(" & ") !== -1) {
      typemap[title.replaceAll(" & ", " and ")] = id;
    }
    if (title.indexOf(" and ") !== -1) {
      typemap[title.replaceAll(" and ", " & ")] = id;
    }
    if (title.endsWith(" part ii")) {
      typemap[title.substring(0, title.length - 8) + " ii"] = id;
    }
    if (title.indexOf('leaderboard') !== -1) {
      typemap[title.replace('leaderboard', 'leader board')] = id;
    }
    if (title.indexOf('leader board') !== -1) {
      typemap[title.replace('leader board', 'leaderboard')] = id;
    }


    // Roman <-> Arabic anywhere in title (longest match first to avoid partial matches)
    // No 'g' flag — avoids stateful lastIndex bug with test() + replace()
    const romanArabicPairs = [
      [' x',    ' 10'],
      [' ix',   ' 9'],
      [' viii', ' 8'],
      [' vii',  ' 7'],
      [' vi',   ' 6'],
      [' v',    ' 5'],
      [' iv',   ' 4'],
      [' iii',  ' 3'],
      [' ii',   ' 2'],
    ];
    for (const [roman, arabic] of romanArabicPairs) {
      const romanRe = new RegExp(`${roman}(?=\\s|:|$|-|\\.)`);
      const arabicRe = new RegExp(`${arabic}(?=\\s|:|$|-|\\.)`);

      if (romanRe.test(title)) {
        const aliased = title.replace(romanRe, arabic);
        typemap[aliased] = id;
        if (aliased.indexOf(':') !== -1) {
          addBeforeSep(aliased, aliased.indexOf(':'), 1);
        }
        if (aliased.indexOf(' - ') !== -1) {
          addBeforeSep(aliased, aliased.indexOf(' - '), 3);
        }
      }
      if (arabicRe.test(title)) {
        const aliased = title.replace(arabicRe, roman);
        typemap[aliased] = id;
        if (aliased.indexOf(':') !== -1) {
          addBeforeSep(aliased, aliased.indexOf(':'), 1);
        }
        if (aliased.indexOf(' - ') !== -1) {
          addBeforeSep(aliased, aliased.indexOf(' - '), 3);
        }
      }
    }
  }

  cleanFileName = (filename) => {
    const dotIdx = filename.lastIndexOf('.');
    return dotIdx > 0 ? filename.slice(0, dotIdx) : filename;
  }

  async getMetaDataByFileName(type, filename) {
    const alias = AppRegistry.instance.getAlias(type);
    if (!this.titleLookups?.[alias]) return null;
    const baseName = this.cleanFileName(filename);

    // console.log(`[GameRegistry] Attempting name lookup for '${baseName}' (${type})`);
    return await this.getMetaDataByMediaTitle(type, baseName);
  }
}

const GameRegistry = new GameRegistryImpl();

export default GameRegistry;